import { render, staticRenderFns } from "./invoiceMessage.vue?vue&type=template&id=cfdba77e&scoped=true"
import script from "./invoiceMessage.vue?vue&type=script&lang=js"
export * from "./invoiceMessage.vue?vue&type=script&lang=js"
import style0 from "./invoiceMessage.vue?vue&type=style&index=0&id=cfdba77e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfdba77e",
  null
  
)

export default component.exports